import Documento from "./Documento";

export default class DocumentoAssociacao {
    id: number;
    documento: Documento | null;
    documentoAssociado: Documento | null;

    constructor(
        id: number = 0,
        documento: Documento | null = null,
        documentoAssociado: Documento | null = null
    ) {
        this.id = id;
        this.documento = documento;
        this.documentoAssociado = documentoAssociado;
    }
}